var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"address-item"},[_c('van-address-edit',{attrs:{"address-info":_vm.addressInfo,"area-list":_vm.areaList,"tel-validator":_vm.validator},on:{"save":_vm.onSave}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }